module.exports = __webpack_public_path__ + "static/media/3.3e899008.jpg";